/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"

import { Button, Input, Spin } from "@duxton-web/ui"
import { Form } from "grab-ui"
import { useTranslationsMapTyped } from "hooks/useTranslationsMapTyped"
import { TroyWebTracker } from "utils/tracking"
import { EventActionEng, EventCategoryEng } from "constants/tracking"
import styles from "./TranslationDrawer.modules.css"

export interface TranslationDrawerFormProps extends FormComponentProps {
  initialValue?: string
  isAutoTranslate?: boolean
  onResetTranslation(): void
  formName: string
  formKey: string
  isMandatory?: boolean
  disabled?: boolean
  loading?: boolean
}

export function TranslationDrawerForm({
  form,
  initialValue,
  formKey,
  isAutoTranslate,
  onResetTranslation,
  isMandatory,
  formName,
  disabled,
  loading,
}: TranslationDrawerFormProps) {
  const textMap = useTranslationsMapTyped({
    translateButtonText: "menu.drawers.item.buttons.translate",
    warningRequired: "menuTranslation.errorRequired",
    buttonTranslate: "menuTranslation.buttonTranslate",
  })

  const handleResetTranslation = () => {
    TroyWebTracker.sendEvent({
      category: EventCategoryEng.translationValueFetch,
      action: EventActionEng.resetTranslationFetch,
    })
    onResetTranslation()
  }

  const { getFieldDecorator } = form

  return (
    <div data-testid="translation-drawer-form">
      <Form.Item label={formName.toUpperCase()} className={styles.titleForm}>
        {loading ? (
          <Spin size="small" className={styles.titleButton} />
        ) : (
          !!isAutoTranslate && (
            <Button
              type="link"
              className={styles.titleButton}
              onClick={handleResetTranslation}
              disabled={disabled}
            >
              {textMap.buttonTranslate}
            </Button>
          )
        )}
        {getFieldDecorator(formKey, {
          initialValue,
          rules: [
            {
              required: isMandatory,
              message: textMap.warningRequired,
            },
          ],
        })(<Input data-testid="input-name-translation" disabled={disabled} />)}
      </Form.Item>
    </div>
  )
}
